import type { CSSProperties } from "react";

/** Local preview uses the same orientation as the published camera. */
export function localCameraVideoStyle(
  _isLocal: boolean,
  base: CSSProperties = {},
): CSSProperties {
  return base;
}
